import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { ClientAccountDispatcher } from "./Variable";

export interface ClientAccountStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ClientAccountStatic extends BaseStore<ClientAccountStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ClientAccountDispatcher, (actionData) => this.onClientAccountStoreResponse(actionData));
    }

    public getLastResult(): ClientAccountStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ClientAccountStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onClientAccountStoreResponse(actionData): void {
        // debugger;
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}